import { Injectable } from '@angular/core';
import { FormBuilder, ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';
import { Scope } from 'app/models/scope';

@Injectable({ providedIn: 'root' })
export class ScopeService{
    constructor( private formBuilder: FormBuilder) { }
    getScopeFormGroup(scope: Scope = null, isRequired: boolean = false){
        return this.formBuilder.group({
            id: [undefined],
            users: [ scope ? scope.users: []],
            teams: [ scope ? scope.teams: []],
            contacts: [ scope? scope.contacts: []]
        }, {validators: this.scopeValidator(isRequired)})
    }

    initScope(): Scope{
        return {
            id: undefined,
            contacts:[],
            teams:[],
            users:[]
        }
    }

    scopeValidator(isRequired: boolean = false): ValidatorFn {

        return (frm: FormGroup): ValidationErrors => {
    
          const users = frm.get('users');
          const teams = frm.get('teams');
          const contacts = frm.get('contacts');

          if (isRequired && users && teams && contacts && users.value.length == 0 && teams.value.length == 0 && contacts.value.length == 0) {
              return { 'scopeRequired': true };
          }
    
          return null;
        };
      }
}